import {ActorBypassMode} from '../bypass-actors-types'

export const UNSUPPORTED_BYPASS_MODES_BY_ACTOR_TYPE: Record<string, ActorBypassMode[]> = {
  DeployKey: [ActorBypassMode.PRS_ONLY],
  RepositoryMigration: [ActorBypassMode.PRS_ONLY],
}
